exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-wrapper[data-v-93b51a9a] {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-wrap: wrap;\r\n    min-height: 100vh;\n}\r\n", ""]);

// exports
